import type { ReactNode } from "react";
import { Modal } from "./Modal";

/** Confirmation before anything destructive or irreversible. */
export function ConfirmDialog({
  title, body, confirmLabel = "Confirm", cancelLabel = "Cancel",
  tone = "accent", onConfirm, onCancel,
}: {
  title: ReactNode; body?: ReactNode;
  confirmLabel?: string; cancelLabel?: string;
  tone?: "accent" | "neg";
  onConfirm: () => void; onCancel: () => void;
}) {
  return (
    <Modal
      title={title}
      onClose={onCancel}
      footer={
        <>
          <button className="btn btn-secondary" onClick={onCancel}>{cancelLabel}</button>
          <button className="btn btn-primary" onClick={onConfirm}
                  style={tone === "neg" ? { background: "var(--neg)", boxShadow: "none" } : undefined}>
            {confirmLabel}
          </button>
        </>
      }
    >
      {body && <p className="form-help" style={{ fontSize: "var(--t-body)", lineHeight: 1.5 }}>{body}</p>}
    </Modal>
  );
}
